export class PlayButton {

    public element: HTMLDivElement;

    public onComplete = e5.Signal.create<[]>();
    public onStart = e5.Signal.create<[]>();

    private _canvas: HTMLCanvasElement;
    private _ctx: CanvasRenderingContext2D;

    private _progress: number = 0;

    constructor(size: number = 80, private _duration: number = 1, icon: string = "icon-420") {
        size = Math.round(size);

        this.element = document.createElement("div");
        this.element.className = "play-button";
        this.element.innerHTML = `
        <canvas class="play-button-canvas" width="${size}" height="${size}"></canvas>
        <div class="play-button-icon ${icon}"></div>
        `;
        this.element.style.width = size + "px";
        this.element.style.height = size + "px";
        this.element.style.lineHeight = size + "px";
        this.element.style.fontSize = Math.round(size / 10) * 6 + "px";

        this._canvas = this.element.querySelector<HTMLCanvasElement>(".play-button-canvas");
        this._ctx = this._canvas.getContext("2d");
    }

    public clear(): void {
        this.progress = 0;
        gsap.killTweensOf(this);
    }

    public start(): void {
        this.onStart.dispatch();
        this.progress = 0;
        gsap.to(this, {
            duration: this._duration,
            progress: 1,
            ease: "none"
        });
    }

    private get progress(): number {
        return this._progress;
    }

    private set progress(value: number) {
        value = e5.Calc.clamp(value, 0, 1);
        if (this._progress === value) {
            return;
        }
        this._progress = value;

        var ctx = this._ctx;
        ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);

        var cx = this._canvas.width * 0.5;
        var cy = this._canvas.height * 0.5;
        var radius = Math.min(cx, cy) - 3;
        ctx.beginPath();

        var offset = -Math.PI * 0.5;
        ctx.arc(cx, cy, radius, offset, this._progress * (2 * Math.PI) + offset);

        var alpha = 1 - (value) ** 2;
        // alpha = 0.5;
        ctx.strokeStyle = "rgba(255, 255, 255, " + alpha + ")";
        ctx.lineWidth = 4;
        ctx.stroke();

        if (this._progress == 1) {
            this.onComplete.dispatch();
        }
    }
}